import { render, staticRenderFns } from "./TaxFund.vue?vue&type=template&id=71e1255e"
import script from "./TaxFund.vue?vue&type=script&lang=js"
export * from "./TaxFund.vue?vue&type=script&lang=js"
import style0 from "./TaxFund.vue?vue&type=style&index=0&id=71e1255e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports